import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useFields (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('fieldsChanged', callback),
    () => state.fields
  )
}
